export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff8d0280a2218e5832a7c20289015081cb2028dce&name=fetchTypeahead!'